// Mock data for Papuecas 24 Real Estate Landing Page

export const translations = {
  es: {
    nav: {
      project: 'El Proyecto',
      renders: 'Diseño',
      currentState: 'Estado Actual',
      location: 'Ubicación',
      estepona: 'Estepona',
      contact: 'Contacto'
    },
    hero: {
      title: 'Papuecas 24',
      subtitle: 'Propiedad en venta con proyecto y licencia de obra aprobada. Lista para construir.',
      cta: 'Solicitar Información'
    },
    project: {
      title: '¿Qué se vende?',
      description: 'Se vende la propiedad en su estado actual junto con el proyecto arquitectónico completo y la licencia de obra ya aprobada por el Ayuntamiento. Puedes empezar la construcción de inmediato.',
      badge: 'Licencia Aprobada · Lista para construir',
      features: [
        { label: 'Dormitorios', value: '4' },
        { label: 'Construcción', value: '~180 m²' },
        { label: 'Plantas', value: '3 + Torreón' },
        { label: 'Licencia', value: 'Aprobada' }
      ],
      includes: {
        title: 'La venta incluye',
        items: [
          'Propiedad en estado actual (a reformar)',
          'Proyecto arquitectónico completo',
          'Licencia de obra aprobada',
          'Planos de ejecución detallados'
        ]
      },
      options: {
        title: 'Dos opciones de desarrollo',
        option1: {
          title: 'Vivienda de Lujo',
          description: '4 dormitorios distribuidos en 3 plantas más torreón, con piscina privada en azotea y terraza solarium con vistas espectaculares.'
        },
        option2: {
          title: 'Posibilidad de Ampliación',
          description: 'El proyecto permite ampliar hasta 260m² para convertir la propiedad en un exclusivo hotel boutique en el corazón del Casco Antiguo.'
        }
      }
    },
    renders: {
      title: 'El Diseño del Proyecto',
      subtitle: 'Así quedará la vivienda una vez construida'
    },
    currentState: {
      title: 'Estado Actual de la Propiedad',
      subtitle: 'Esto es lo que se vende: la propiedad a rehabilitar'
    },
    location: {
      title: 'Ubicación',
      subtitle: 'Calle Papuecas 24, Casco Antiguo de Estepona',
      address: 'Calle Papuecas 24, 29680 Estepona, Málaga'
    },
    estepona: {
      title: 'Estepona',
      subtitle: 'El Jardín de la Costa del Sol',
      description: 'Estepona es uno de los pueblos más encantadores de la Costa del Sol. Con su casco antiguo de calles blancas adornadas con flores, sus playas de arena dorada y su ambiente auténtico andaluz, es el lugar perfecto para vivir el estilo de vida mediterráneo.'
    },
    contact: {
      title: 'Contacto',
      subtitle: '¿Interesado en esta oportunidad única?',
      cta: 'Solicitar Información',
      phone: 'Teléfono',
      email: 'Email'
    },
    footer: {
      rights: 'Todos los derechos reservados'
    }
  },
  en: {
    nav: {
      project: 'The Project',
      renders: 'Design',
      currentState: 'Current State',
      location: 'Location',
      estepona: 'Estepona',
      contact: 'Contact'
    },
    hero: {
      title: 'Papuecas 24',
      subtitle: 'Property for sale with approved project and building permit. Ready to build.',
      cta: 'Request Information'
    },
    project: {
      title: 'What is for sale?',
      description: 'The property is sold in its current state together with the complete architectural project and the building permit already approved by the City Council. You can start construction immediately.',
      badge: 'Approved License · Ready to build',
      features: [
        { label: 'Bedrooms', value: '4' },
        { label: 'Construction', value: '~180 m²' },
        { label: 'Floors', value: '3 + Tower' },
        { label: 'License', value: 'Approved' }
      ],
      includes: {
        title: 'The sale includes',
        items: [
          'Property in current state (to renovate)',
          'Complete architectural project',
          'Approved building permit',
          'Detailed execution plans'
        ]
      },
      options: {
        title: 'Two development options',
        option1: {
          title: 'Luxury Home',
          description: '4 bedrooms distributed over 3 floors plus tower level, with private rooftop pool and solarium terrace with stunning views.'
        },
        option2: {
          title: 'Expansion Possibility',
          description: 'The project allows expansion up to 260m² to convert the property into an exclusive boutique hotel in the heart of the Old Town.'
        }
      }
    },
    renders: {
      title: 'Project Design',
      subtitle: 'This is how the property will look once built'
    },
    currentState: {
      title: 'Current State of the Property',
      subtitle: 'This is what is for sale: the property to be renovated'
    },
    location: {
      title: 'Location',
      subtitle: 'Calle Papuecas 24, Estepona Old Town',
      address: 'Calle Papuecas 24, 29680 Estepona, Málaga'
    },
    estepona: {
      title: 'Estepona',
      subtitle: 'The Garden of the Costa del Sol',
      description: 'Estepona is one of the most charming towns on the Costa del Sol. With its old town of white streets adorned with flowers, its golden sand beaches and its authentic Andalusian atmosphere, it is the perfect place to live the Mediterranean lifestyle.'
    },
    contact: {
      title: 'Contact',
      subtitle: 'Interested in this unique opportunity?',
      cta: 'Request Information',
      phone: 'Phone',
      email: 'Email'
    },
    footer: {
      rights: 'All rights reserved'
    }
  }
};

export const contactInfo = {
  email: 'info@papuecas24.es',
  phone: '+34 610 332 656',
  whatsapp: '+34610332656',
  address: 'Calle Papuecas 24, 29680 Estepona, Málaga'
};

export const projectPDF = {
  url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/c0h0rs6m_EXECUTIVE%20DRAWINGS%202026.pdf',
  name: 'Planos del Proyecto - Papuecas 24'
};

export const floorDetails = {
  es: {
    title: 'Distribución',
    floors: [
      {
        name: 'Planta Baja',
        area: '84 m²',
        rooms: ['Recibidor (20m²)', 'Estar-Comedor-Cocina (37m²)', 'Estar Invitados (11m²)', 'Dormitorio Invitados (6m²)', 'Baño Invitados (3m²)', 'Baño (6m²)']
      },
      {
        name: 'Primera Planta',
        area: '48 m²',
        rooms: ['Dormitorio Principal (18m²)', 'Baño Principal (3m²)', 'Dormitorio 2 (13m²)', 'Baño (4m²)', 'Distribuidor (10m²)']
      },
      {
        name: 'Torreón',
        area: '26 m²',
        rooms: ['Dormitorio (13m²)', 'Zona de Estar', 'Acceso a Terraza']
      },
      {
        name: 'Azotea',
        area: '32 m²',
        rooms: ['Piscina Privada (5m²)', 'Terraza Solarium', 'Placas Solares']
      }
    ],
    totalArea: '~180 m²',
    features: ['Piscina en azotea', 'Placas solares', 'Aerotermia', 'Suelo radiante', 'LED integrado']
  },
  en: {
    title: 'Floor Distribution',
    floors: [
      {
        name: 'Ground Floor',
        area: '84 m²',
        rooms: ['Foyer (20m²)', 'Living-Dining-Kitchen (37m²)', 'Guest Living (11m²)', 'Guest Bedroom (6m²)', 'Guest Bathroom (3m²)', 'Bathroom (6m²)']
      },
      {
        name: 'First Floor',
        area: '48 m²',
        rooms: ['Master Bedroom (18m²)', 'Master Bathroom (3m²)', 'Bedroom 2 (13m²)', 'Bathroom (4m²)', 'Hallway (10m²)']
      },
      {
        name: 'Tower Level',
        area: '26 m²',
        rooms: ['Bedroom (13m²)', 'Living Area', 'Terrace Access']
      },
      {
        name: 'Rooftop',
        area: '32 m²',
        rooms: ['Private Pool (5m²)', 'Solarium Terrace', 'Solar Panels']
      }
    ],
    totalArea: '~180 m²',
    features: ['Rooftop pool', 'Solar panels', 'Aerothermal system', 'Underfloor heating', 'Integrated LED']
  }
};

export const renderImages = [
  // HERO / PATIO
  {
    id: 1,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/ucmohgla_imagen%20web-02.png',
    alt: { es: 'Patio interior', en: 'Interior patio' }
  },
  // PLANTA BAJA
  {
    id: 2,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/c1iwje5a_2.jpg',
    alt: { es: 'Salón con chimenea', en: 'Living room with fireplace' }
  },
  {
    id: 3,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/l7e2nagm_3.jpg',
    alt: { es: 'Escaleras y cocina', en: 'Stairs and kitchen' }
  },
  {
    id: 4,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/22iln1vb_WhatsApp%20Image%202026-01-26%20at%2012.30.16.jpeg',
    alt: { es: 'Cocina', en: 'Kitchen' }
  },
  {
    id: 5,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/orm0vjw7_WhatsApp%20Image%202026-01-26%20at%2012.30.23.jpeg',
    alt: { es: 'Interior con escaleras', en: 'Interior with stairs' }
  },
  {
    id: 6,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/vqof7qi8_WhatsApp%20Image%202026-01-26%20at%2012.30.30.jpeg',
    alt: { es: 'Entrada', en: 'Entrance' }
  },
  // PLANTA ALTA - DORMITORIOS
  {
    id: 7,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/bkkexzv4_5.jpg',
    alt: { es: 'Pasillo hacia dormitorio', en: 'Hallway to bedroom' }
  },
  {
    id: 8,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/tofxr7po_4.jpg',
    alt: { es: 'Dormitorio con baño', en: 'Bedroom with bathroom' }
  },
  {
    id: 9,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/37s50l72_6.jpg',
    alt: { es: 'Dormitorio principal', en: 'Master bedroom' }
  },
  {
    id: 10,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/wxjb2to2_7.jpg',
    alt: { es: 'Dormitorio con vista al baño', en: 'Bedroom with bathroom view' }
  },
  {
    id: 11,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/7ajmaeak_8.jpg',
    alt: { es: 'Baño principal', en: 'Main bathroom' }
  },
  {
    id: 12,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/f8s5tz87_9.jpg',
    alt: { es: 'Dormitorio secundario', en: 'Secondary bedroom' }
  },
  // EXTERIOR
  {
    id: 13,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/x4hx81s5_WhatsApp%20Image%202026-01-26%20at%2012.29.58.jpeg',
    alt: { es: 'Fachada exterior', en: 'Exterior facade' }
  }
];

export const currentStateImages = [
  {
    id: 1,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/bobd9wkm_WhatsApp%20Image%202026-01-28%20at%2013.59.20.jpeg',
    alt: { es: 'Fachada actual', en: 'Current facade' }
  },
  {
    id: 2,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/72wevyxq_WhatsApp%20Image%202026-01-28%20at%2015.34.04%20%281%29.jpeg',
    alt: { es: 'Patio', en: 'Patio' }
  },
  {
    id: 3,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/gl54cyi1_WhatsApp%20Image%202026-01-28%20at%2015.34.04.jpeg',
    alt: { es: 'Patio interior', en: 'Interior patio' }
  },
  {
    id: 4,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/gdsyrzow_WhatsApp%20Image%202026-01-28%20at%2013.59.20%20%281%29.jpeg',
    alt: { es: 'Interior', en: 'Interior' }
  },
  {
    id: 5,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/moqmllzs_WhatsApp%20Image%202026-01-28%20at%2013.59.20%20%282%29.jpeg',
    alt: { es: 'Habitación', en: 'Room' }
  },
  {
    id: 6,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/yl554un7_WhatsApp%20Image%202026-01-28%20at%2013.59.20%20%283%29.jpeg',
    alt: { es: 'Vista exterior', en: 'Exterior view' }
  },
  {
    id: 7,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/jmpe3hr5_WhatsApp%20Image%202026-01-28%20at%2015.34.04%20%282%29.jpeg',
    alt: { es: 'Interior con mueble', en: 'Interior with furniture' }
  },
  {
    id: 8,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/ni7dpulv_WhatsApp%20Image%202026-01-28%20at%2015.34.04%20%283%29.jpeg',
    alt: { es: 'Espacio interior', en: 'Interior space' }
  },
  {
    id: 9,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/5ht5zd7y_WhatsApp%20Image%202026-01-28%20at%2015.34.04%20%284%29.jpeg',
    alt: { es: 'Interior con techo de madera', en: 'Interior with wooden ceiling' }
  },
  {
    id: 10,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/ki9kvt3d_WhatsApp%20Image%202026-01-28%20at%2015.34.04%20%285%29.jpeg',
    alt: { es: 'Escaleras', en: 'Stairs' }
  }
];

export const esteponaImages = [
  {
    id: 1,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/x4jyw7yd_Estepona%201.png',
    alt: { es: 'Casco Antiguo de Estepona', en: 'Estepona Old Town' }
  },
  {
    id: 2,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/0wttnjh4_estepona%202.jpg',
    alt: { es: 'Calles con flores', en: 'Streets with flowers' }
  },
  {
    id: 3,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/i0qn6go5_estepona%203.avif',
    alt: { es: 'Playa de Estepona', en: 'Estepona Beach' }
  },
  {
    id: 4,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/17evpe1f_estepona%204.jpg',
    alt: { es: 'Atardecer en la playa', en: 'Beach sunset' }
  },
  {
    id: 5,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/6z6eymqu_Estepona%205.jpg',
    alt: { es: 'Vista panorámica', en: 'Panoramic view' }
  },
  {
    id: 6,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/2adg5329_Estepona%207.webp',
    alt: { es: 'Puesta de sol', en: 'Sunset' }
  },
  {
    id: 7,
    url: 'https://customer-assets.emergentagent.com/job_803ea0a9-3d70-4dd0-b0b2-088e151e6735/artifacts/dsegwmdx_Estepona%208.jpg',
    alt: { es: 'Costa del Sol', en: 'Costa del Sol' }
  }
];
